import React, { useMemo } from 'react';
import { Provider } from 'react-redux';

import configureStore from 'bundles/connect/components/store/configure';
import CallConsoleHeader, { type CallConsoleHeaderProps } from './call_console_header';
import CallListItem from '../call_list/call_list_item';
import { Container } from 'react-bootstrap-5';
import { type Activity, type CallTemplate, type InsightsProperty, type Profile } from 'bundles/connect/types';
import OffMarketPropertyOffcanvas from '../search/components/off_market_property_offcanvas';

// TODO_GL: Move this into call_list_item once converted to TS
type CallListItemProps = {
  activities?: Activity[];
  callListId: number;
  callTemplates: CallTemplate[];
  insightsProperty: InsightsProperty;
  profile: Profile;
  connectPropertyId: number;
}

type CallConsoleProps = CallConsoleHeaderProps & CallListItemProps

export default function CallConsole({
  activities,
  callConsoleData,
  callListLength,
  callTemplates,
  profile,
  remainingCredits,
}: CallConsoleProps) {
  const store = useMemo(() => configureStore({
    activities,
    callConsoleData,
    ui: {
      profile,
    }
  }), []);

  const HEADER_PROPS = {
    callConsoleData,
    callListLength,
    remainingCredits
  };

  const CALL_LIST_ITEM_PROPS = {
    callConsoleData,
    activities,
    callTemplates
  };

  return (
    <Provider store={store}>
      <div className="bg-white border-bottom py-4">
        <Container fluid>
          <CallConsoleHeader {...HEADER_PROPS} />
        </Container>
      </div>
      <div className="flex-grow-1 py-6 px-md-6">
        <CallListItem {...CALL_LIST_ITEM_PROPS} />
      </div>
      <OffMarketPropertyOffcanvas fromConsole={false} />
    </Provider>
  );
}
